export default __webpack_public_path__ + "static/7-471cf0db62c9df2ff94321cc258ca5a8.jpg";